import React from 'react';
import AgeSelect from '../component/ageSelect';
import CheckBox from '../component/checkBox';

let checkBoxDataHindi = {
  ch1: "मेरी उम्र 65 साल से ज़्यादा है",
  tag1: "over65Yrs",
  ch2: "मुझे लंबे समय से एक बिमारी है ( जैसे - डायबिटीज, उच्च रक्तचाप या सीओपीडी)",
  tag2: "longTermHealthProblems",
  ch3: "दिए गए विकल्प मेरे लिए अमान्य है",
  tag3: "HealthRisksNone",
  sub: 'जमा करें'
}

let checkBoxDataEnglish = {
  ch1: "I am over 65 years of age",
  tag1: "over65Yrs",
  ch2: "I have long term health problem(eg: diabetes or hypertension or COPD)",
  tag2: "longTermHealthProblems",
  ch3: "None of the above are applicable to me",
  tag3: "HealthRisksNone",
  sub: "Submit"
}

let questions = [
  {
    id: '1',
    message: 'Hello, Please tell us your language?',
    trigger: 'language',
  },
  {
    id: 'language',
    options: [
      { value: 'english', label: 'English', trigger: 'e1' },
      { value: 'hindi', label: 'हिन्दी', trigger: 'h1' },
    ],
  },
  {
    id: 'e1',
    message: 'What is your age?',
    trigger: 'englishage',
  },
  {
    id: 'englishage',
    component: <AgeSelect />,
    waitAction: true,
    trigger: '3',
  },
  {
    id: '3',
    message: 'Can you please select your gender?',
    trigger: 'englishgender',
  },
  {
    id: 'englishgender',
    options: [
      { value: 'male', label: 'Male', trigger: '4' },
      { value: 'female', label: 'Female', trigger: '4' },
    ],
  },
  {
    id: '4',
    message: 'Do you have cough, runny nose (cold) or sorethroat at present?',
    trigger: 'englishSymptomsQuery',
  },
  {
    id: 'englishSymptomsQuery',
    options: [
      { value: 'Yes, I have one or more of these', label: 'Yes, I have one or more of these', trigger: '5' },
      { value: 'No, I do not have any of these', label: 'No, I do not have any of these', trigger: '5' },
    ],
  },
  {
    id: '5',
    message: 'Have you travelled outside the country in the last 30 days?',
    trigger: 'englishTravelExposureQuery',
  },
  {
    id: 'englishTravelExposureQuery',
    options: [
      { value: 'Yes, I have travelled recently', label: 'Yes, I have travelled recently', trigger: '6' },
      { value: 'No, I have not travelled recently', label: 'No, I have not travelled recently', trigger: '6' },
    ],
  },
  {
    id: '6',
    message: 'Have you come in close contact with someone who is diagnosed with coronavirus(Covid-19) or is suspected to have it? Close contact means someone you live with or work closely with.',
    trigger: 'englishCaseExposureQuery',
  },
  {
    id: 'englishCaseExposureQuery',
    options: [
      { value: 'Yes, I have', label: 'Yes, I have', trigger: '7' },
      { value: 'No, I have not', label: 'No, I have not', trigger: '7' },
    ],
  },
  {
    id: '7',
    message: 'Is any of the following applicable to you ?',
    trigger: 'englishHealthRisksQuery',
  },
  {
    id: 'englishHealthRisksQuery',
    component: <CheckBox checkBoxData={checkBoxDataEnglish}/>,
    waitAction: true,
    end: true
  },
  {
    id: 'h1',
    message: 'आपकी उम्र क्या हैं?',
    trigger: 'hindiage',
  },
  {
    id: 'hindiage',
    component: <AgeSelect />,
    waitAction: true,
    trigger: 'h3',
  },
  {
    id: 'h3',
    message: 'अपना लिंग चुनें?',
    trigger: 'hindigender',
  },
  {
    id: 'hindigender',
    options: [
      { value: 'पुरुष', label: 'पुरुष', trigger: 'h4' },
      { value: 'महिला', label: 'महिला', trigger: 'h4' },
    ],
  },
  {
    id: 'h4',
    message: 'क्या आपको खांसी, ज़ुखाम, साँस लेने में तकलीफ या गले में खराश है?',
    trigger: 'hindiSymptomsQuery',
  },
  {
    id: 'hindiSymptomsQuery',
    options: [
      { value: 'हाँ, मुझे यह लक्षण हैं ', label: 'हाँ, मुझे यह लक्षण हैं ', trigger: 'h5' },
      { value: 'नहीं', label: 'नहीं', trigger: 'h5' },
    ],
  },
  {
    id: 'h5',
    message: 'क्या पिछले 30 दिनों में आपने विदेश यात्रा की थी ?',
    trigger: 'hindiTravelExposureQuery',
  },
  {
    id: 'hindiTravelExposureQuery',
    options: [
      { value: 'हाँ', label: 'हाँ', trigger: 'h6' },
      { value: 'नहीं ', label: 'नहीं ', trigger: 'h6' },
    ],
  },
  {
    id: 'h6',
    message: 'क्या आप हाल ही में किसी ऐसे व्यक्ति से मिले थे जिसे कोरोना वायरस (कोविड-19) हुआ हो या होने की उम्मीद हो ? या फिर क्या आपके आस पास कोई कोरोना वायरस का मरीज़ है ? ',
    trigger: 'hindiCaseExposureQuery',
  },
  {
    id: 'hindiCaseExposureQuery',
    options: [
      { value: 'हाँ', label: 'हाँ ', trigger: 'h7' },
      { value: 'नहीं', label: 'नहीं', trigger: 'h7' },
    ],
  },
  {
    id: 'h7',
    message: 'निम्नलिखित में से चुनिए :',
    trigger: 'hindiHealthRisksQuery',
  },
  {
    id: 'hindiHealthRisksQuery',
    component: <CheckBox checkBoxData={checkBoxDataHindi}/>,
    waitAction: true,
    end: true
  }
]
export default questions